
import "./RestForOvertimeWork.scss";
import DatePeriodControlled from "../../../../../../../common/Inputs/DatePeriodControlled/DatePeriodControlled";
import RestForOvertimeWorkApplication
    from "../../../../../../../../frontend.classes/Requests/RestForOvertimeWork.application";
import BlueButton from "../../../../../../../common/Button/BlueButton/BlueButton";
import {
    addPeriodHandlerCurrentRequest,
} from "../../../../../../../../redux/actions/Requests/currentRequestControls/addPeriodHandler.currentRequest";
import {
    clearAttachmentsAction,
} from "../../../../../../../../redux/actions/Requests/Attachments/clearAttachments.action";
import {
    emptyCurrentRequest,
} from "../../../../../../../../redux/actions/Requests/currentRequestControls/emptyCurrentRequest";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {v4 as uuidv4} from "uuid";
import moment from "moment/moment";


const RestForOvertimeWork = (
    {
        setRequestStatus,
        requestStatus,
        requestOption,
        setRequestState,
    }
) => {
    const datesForRange = {
        minFrom: new Date(moment().add(1, "days")),
    };
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();
    const queryId = searchParams.get("id");

    const currentRequest = useSelector(state => state.requests.currentRequest);
    function addPeriodHandler(e) {
        dispatch(addPeriodHandlerCurrentRequest());
    }

    return (
        <section className="rest-for-overtime-work">
            {
                currentRequest && currentRequest.periods && currentRequest.periods.length ?
                    currentRequest.periods.map(
                        (period, index) => {
                            return (
                                <DatePeriodControlled
                                    allowsMultipleDateRanges={true}
                                    datesForRange={datesForRange}
                                    setRequestState={setRequestState}
                                    periodsLength={currentRequest.periods.length}
                                    key={uuidv4()}
                                    parentStyle={"postpone-vacation"}
                                    period={period}
                                    label={{from: "Дата начала отдыха *", to: "Дата окончания отдыха *"}}
                                    index={index}/>
                            );
                        }) :
                    <div style={{display: "flex", gap: "15px"}}>
                        <h3 style={{fontSize: "15px"}}>Добавить период</h3>
                        <BlueButton
                            parentStyle={"postpone-vacation"}
                            handler={addPeriodHandler}
                        />
                    </div>
            }
        </section>
    );
};

export default RestForOvertimeWork;
